module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title"
  }, [_c('a', [_vm._v("DECEMBER 29TH, 1952")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have "), _c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("started to write this down many times in the past twenty years—ever since I turned seventy, and felt that every day of life was a special gift. Like many an old woman, I’ve chosen, to spend that gift on my grandchildren and their children, with the odd moment or hour given over to the church, and do not regret any of that.")])]), _c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But last month I had a small stroke and though I have recovered most of my faculties, it’s obvious that I have outstayed my welcome on this world. I do have a strange story to tell, and have put off telling it for too long.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("Parts ")]), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("of the story would be embarrassing to my son, especially in his particular prominence—so I have agreed to leave this book in his keeping, not to be printed until after his death, or even after the death of his own son.")])]), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps from that distant perspective, the more fantastic parts of this account will seem less strange.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the Depression, I helped support my family by writing stories for the pulp magazines, under a variety of male pseudonyms. I stopped writing during the War, paper shortages having closed most of my markets, and never went back to it. But I was skillful with dialogue in those days, and with the reader’s indulgence I will have recourse to that artifice in this memoir. Of course I don’t remember the exact words of conversations more than a half-century old. I do remember having had the conversations, though, and trust that I can reconstruct the sense of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My son has set me up in this unused parlor with a comfortable desk and chair and a bookshelf with all of my diaries. I count forty-three of them, most of them covering more than one year. The earliest starts in 1868, when I was ten, but nothing of much interest happens in my life until the nineties.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("Still, ")]), _c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("a few things for the record, as they say nowadays. I was born in Helen’s Mill, Georgia, in 1858, on a plantation with slaves. I remember almost nothing of that except the image of a large Negro woman, who I’m told was my nurse Daisy. I’m told I played with the slave children.")])]), _c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the children (the white children) in the family were sent to stay with relatives in Philadelphia after Fort Sumter, in 1861. My father correctly divined that the war would not go that far north. Though Gettysburg was close enough that we knew people who went out to watch the battle, and hear the speeches afterwards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sherman’s troops burned our plantation just before Atlanta, and I suppose my mother and father died during that invasion. We never heard from them again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was really no room for myself and my sisters and brother with Aunt Karen and Uncle Claude, so I was sent to Dorothy Partridge’s Boarding School, a strict Methodist place where I stayed until rescued by Wellesley in 1875.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("Some ")]), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("of the girls complained about Wellesley’s strictness, but to me it was emancipation. At Partridge’s we had supervised prayer five times a day. Miss Partridge could read your mind, and she saw nothing there but sin. When we were actually caught in sin, we were sent to the Forgiveness Room, a dark closet with nothing but a large candle, a prayer rail, and a chamber pot with no cover. A truly bad sin, like sneaking in candy, would put you in that room for twenty-four hours, with no food or water and little air, sore from the switch or the rod. So to me the proctors and housemistresses of Wellesley were nothing. At worst, they might send me to a detention room, with only a Bible to contemplate. But that was no punishment at all. I’ve always enjoyed reading the Bible, trying to puzzle things out.")])]), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At this end of my life, there is much to puzzle over for which the Bible is little help. But I still read it daily, peering now through a magnifying glass. Even this large-type version is too difficult for my spectacles alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Wellesley I studied natural philosophy and literature. I suppose it was as good a preparation as a woman could have, then or now, for the strange trials I was to face with the Raven.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("I ")]), _c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("shouldn’t call them trials, because they were not intended as such. My actual trials, most of a century’s physical and mental pain, have been provided by myself and other humans, and they have not been as great as most people’s.")])]), _c('a', {
    attrs: {
      "id": "p7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3597c846","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface001.vue
// module id = 75
// module chunks = 0